import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { toast } from '@core/components';
import { useAuth } from '@core/contexts/AuthContext';
import { readLocalItem, writeLocalItem } from '@core/utils/localStorage';

const STORAGE_KEY = 'lv.flash.layoutTip.v1';

const UsernameFlashDialog: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  const open =
    !dismissed &&
    navigator.platform.startsWith('Mac') &&
    (user?.username.toLowerCase() === 'kennethsantos' ||
      user?.username.toLowerCase() === 'NimoCanaman') &&
    readLocalItem(STORAGE_KEY) == null;

  useEffect(() => {
    if (!open) {
      return;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (!event.metaKey || event.key.toLowerCase() !== 'l') {
        return;
      }
      writeLocalItem(STORAGE_KEY, '1');
      setDismissed(true);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        toast('Press ⌘ + L 🤨', {
          style: {
            fontSize: '1.5rem',
            padding: '16px 24px',
            fontWeight: 600,
          },
        });
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            component="img"
            src="https://i.pinimg.com/originals/4c/23/63/4c236364db3543337354bc3acc1fe792.gif"
            sx={{
              width: 150,
              height: 150,
              flexShrink: 0,
              objectFit: 'contain',
            }}
          />
          <Box minWidth={0}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Hello Nimo!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Please take a moment to explore the new layout by pressing ⌘ + L
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UsernameFlashDialog;
